import React from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import PublicInfoPage from "../components/PublicInfo/PublicInfoPage";

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>Contacto | Alohar</title>
        <meta
          name="description"
          content="Encontrá los canales públicos de contacto de Alohar para soporte de reservas, consultas generales, privacidad y reportes de seguridad o cuenta."
        />
        <link rel="canonical" href="https://alohar.me/contacto" />
      </Helmet>
      <Navbar addSearch={false} hideAlohadorButtons={true} hideSearchButtons={true} />
      <PublicInfoPage
        eyebrow="Soporte y atención"
        title="Cómo contactar a Alohar"
        intro="Si necesitás ayuda con una reserva, el uso de tu cuenta, una consulta general o un tema de privacidad, esta página resume los canales públicos de contacto de Alohar y en qué casos conviene usar cada uno."
        lastUpdated="15 de marzo de 2026"
        highlights={[
          {
            title: "Consultas generales",
            description:
              "Para orientación comercial, dudas sobre el servicio o seguimiento general, podés escribir a hola@alohar.me.",
          },
          {
            title: "Atención por WhatsApp",
            description:
              "Alohar también publica líneas de atención para huéspedes y alohadores cuando la consulta requiere una respuesta más directa.",
          },
          {
            title: "Seguridad y cuenta",
            description:
              "Si detectás accesos no autorizados, suplantación o un problema sensible de cuenta, usá denuncias@alohar.me.",
          },
        ]}
        sections={[
          {
            title: "Canales de contacto disponibles",
            bullets: [
              "Email general: hola@alohar.me.",
              "Seguridad y denuncias de cuenta: denuncias@alohar.me.",
              "Atención a alohadores por WhatsApp: +54 9 11 2818-0202.",
              "Atención a huéspedes por WhatsApp: +54 9 223 301 8749.",
            ],
          },
          {
            title: "Para qué temas podés escribirnos",
            bullets: [
              "Dudas sobre el funcionamiento general de la plataforma.",
              "Consultas relacionadas con reservas, pagos o cancelaciones.",
              "Problemas para ingresar a la cuenta o recuperar acceso.",
              "Situaciones vinculadas a publicaciones, comunicación o incidencias operativas.",
              "Consultas sobre privacidad, uso de datos o actualización de información personal.",
            ],
          },
          {
            title: "Qué información conviene incluir en tu mensaje",
            paragraphs: [
              "Para poder ayudarte más rápido, intentá incluir el nombre del titular de la cuenta, el correo asociado, el número de reserva si existe y una descripción concreta del problema. Si el caso involucra seguridad o acceso, no compartas contraseñas por correo ni por mensajería.",
            ],
          },
          {
            title: "Compromiso de transparencia",
            paragraphs: [
              "Alohar mantiene esta página como punto público de contacto para que huéspedes, alohadores y visitantes puedan encontrar una vía clara de comunicación sin depender de áreas privadas del sitio. Esto ayuda a que la plataforma sea más verificable y entendible antes de registrarse o reservar.",
            ],
          },
        ]}
        relatedLinks={[
          {
            to: "/ayuda",
            label: "Centro de ayuda",
            description: "Antes de escribir, revisá las respuestas más comunes sobre reservas y pagos.",
          },
          {
            to: "/politica-de-privacidad",
            label: "Privacidad",
            description: "Información sobre datos personales, cookies y derechos del usuario.",
          },
          {
            to: "/terminos",
            label: "Términos",
            description: "Reglas generales del servicio y responsabilidades de uso.",
          },
          {
            to: "/quienes-somos",
            label: "Quiénes somos",
            description: "Contexto sobre la plataforma y el tipo de experiencia que ofrece.",
          },
        ]}
      />
      <Footer />
    </div>
  );
};

export default Contact;